"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHeartOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.56 6.54A7.42 7.42 0 0022.26 4c-2 0-4.09 1-6.26 3-2.17-2-4.23-3-6.26-3a7.4 7.4 0 00-5.3 2.54C1.92 9.1.09 13.34 5.65 19L16 28.35 26.35 19c5.56-5.66 3.73-9.9 1.21-12.46zm-2.6 11l-9 8.09-8.9-8.05c-4.77-4.87-3-7.83-1.19-9.64A5.43 5.43 0 019.74 6c1.66 0 3.53 1 5.55 3.09l.71.73.71-.73C18.73 7 20.6 6 22.26 6a5.43 5.43 0 013.87 1.94c1.78 1.81 3.59 4.78-1.13 9.62z" })));
}
exports.default = SvgHeartOutline;
//# sourceMappingURL=HeartOutline.js.map